module.exports = __webpack_public_path__ + "img/step_images_slider.7bd27ef.png";